import(/* webpackMode: "eager", webpackExports: ["ClientProviders"] */ "/vercel/path0/app/providers.tsx");
